import useMobile from "customHooks/useMobile";
import { useContext } from "react";
import { DonatePageContext } from "../../../context/DonatePageContext";
import InfinteDataSoruceHandler from "../../SharedLayoutComponents/InfinteDataSoruceHandler";
import LastUpdatesSkeleton from "../../Skeletons/LastUpdatesSkeleton";
import LastUpdateCard from "./LastUpdateCard";

const LastUpdatesTab = ({
  // item,
  onTouchEnd,
  onTouchStart,
}) => {
  const { url } = useContext(DonatePageContext);
  const isMobile = useMobile("md");
  return (
    <>
      <InfinteDataSoruceHandler
        skeleton={LastUpdatesSkeleton}
        endPoint={`${url.endPoint}/${url.id}/updates`}
        resourceName="item"
        skeletonAmount={1}
        inifiteScrollProps={{
          dontMobile: true,
        }}
        getMoreSkeletonAmount={1}
      >
        <LastUpdateCard
          onTouchEnd={onTouchEnd}
          onTouchStart={onTouchStart}
          isMobile={isMobile}
        />
      </InfinteDataSoruceHandler>
    </>
  );
};
{
  /* <NewActivity /> */
}
export default LastUpdatesTab;
